import Image from 'next/image'
import clsx from 'clsx'

import Breadcrumbs from '../Breadcrumb/Breadcrumb'
import AutoSuggestion from '../AutoSuggestion/AutoSuggestion'

type Props = {
  title: string
  description?: string
  breadcrumbs?: Breadcrumb[]
}

function BlogPageHero({ title, description, breadcrumbs = [] }: Props) {
  return (
    <section>
      <Image
        src="/assets/blog/blog-title-bg.svg"
        alt=""
        width={1336}
        height={620}
        className="hidden md:block w-full absolute"
        priority={true}
      />
      <Image
        src="/assets/blog/blog-title-bg-mob.svg"
        alt=""
        width={1168}
        height={542}
        className="block md:hidden w-full absolute"
        priority={true}
      />
      <div
        className={clsx(
          'container | font-heading | md:text-center | pb-5 md:pb-11 relative',
          breadcrumbs?.length === 0 ? 'pt-14 md:pt-18' : ''
        )}
      >
        {breadcrumbs.length > 0 ? (
          <nav className="bg-transparent  |  flex justify-center | pt-14 md:pt-18 pb-10 px-4 xl:px-0">
            <Breadcrumbs breadcrumbItems={breadcrumbs} />
          </nav>
        ) : null}
        <h1
          className="text-4xl lg:text-5xl font-semibold | max-w-col-8 | mx-auto mb-4"
          dangerouslySetInnerHTML={{ __html: title }}
        />
        {description ? (
          <div
            className="text-sm lg:text-lg | max-w-col-5 | mx-auto mb-10 md:mb-11"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        ) : null}
        <AutoSuggestion
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          onClose={() => {}}
        />
      </div>
    </section>
  )
}

export default BlogPageHero
